import { Icon } from '@iconify/react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogTitle,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Stack,
  styled,
  TextField,
  Typography
} from '@mui/material';
import checkmarkCircle2Fill from '@iconify/icons-eva/checkmark-circle-2-fill';
import { useState, useEffect, useCallback } from 'react';
import * as Yup from 'yup';
import { Form, FormikProvider, useFormik } from 'formik';
import { LoadingButton } from '@mui/lab';
import useIsMountedRef from '../../../../hooks/useIsMountedRef';
import { clipPaymentConfirm, clipTransaction } from '../../../../_apis_/dagpacket';
import useWallet from '../../../../hooks/useWallet';
import useAuth from '../../../../hooks/useAuth';
import { firestore } from '../../../../contexts/FirebaseContext';
import { useSnackbar } from 'notistack';
import { ButtonRecargaMercPago } from '../../../pagos/mercadopago';
import ReportarRecargaForm from './reporteRecarga/ReportarRecargaForm';
import ReportRecarga from './reporteRecarga/ReportRecarga';
import DialogSettingMethodPay from './settingsMethods/DialogSettingMethodPay';
import usePaymentMethodConf from '../../../../hooks/settingsConfHooks/usePaymentMethodConf';

// const PAYMENT_OPTIONS = [
//   {
//     value: 0,
//     title: 'Reporte',
//     description: 'Reporta un recarga de saldo'
//   },
//   // {
//   //   value: 1,
//   //   title: 'Mercado Pago',
//   //   description: 'Usa Mercado Pago para hacer tu recarga'
//   // },

//   {
//     value: 2,
//     title: 'CLIP',
//     description: 'Usa CLIP para hacer tu recarga'
//   }
// ];

// ----------------------------------------------------------------------
const OptionStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 2.5),
  justifyContent: 'space-between',
  borderRadius: theme.shape.borderRadius,
  transition: theme.transitions.create('all'),
  border: `solid 1px ${theme.palette.grey[500_32]}`
}));

export default function AgregarFondosWallet({ setAddSaldo, open, usedUser }) {
  const [selectValue, setSelectValue] = useState(0);
  // const [payment_method, setPayment_method] = useState('');

  console.log('el usuario usado', usedUser);

  const handleChangeSelected = (event) => {
    setSelectValue(Number(event.target.value));
  };

  const handleClose = () => {
    setAddSaldo(false);
  };

  // array de todos lo metodos de pago para luego ser filtrado por el hook usePaymentMethodConf
  const PAYMENT_OPTIONS_HOOK = [
    {
      value: 0,
      id: 'REPORTE',
      title: 'Reportar recarga',
      description: 'Reporta un recarga de saldo',
      component: <ReportRecarga handleClose={handleClose} user={usedUser} />
    },
    {
      value: 1,
      title: 'Mercado Pago',
      id: 'MERCADO_PAGO',
      description: 'Usa Mercado Pago para hacer tu recarga',
      component: <Typography>mercado pago</Typography>
    },
    {
      value: 2,
      title: 'CLIP',
      id: 'CLIP',
      description: 'Usa CLIP para hacer tu recarga',
      component: <ClipPayment handleClose={handleClose} user={usedUser} />
    }
  ];

  // hook para obtener el nuevo array con los metodos de pago permitidos por rol de usuario
  const { allowedMethodArr } = usePaymentMethodConf(PAYMENT_OPTIONS_HOOK);

  // console.log('el nuevo array-------', allowedMethodArr);

  let payment_method;
  if (selectValue === 0) {
    // payment_method = <ReportRecarga handleClose={handleClose} />;
    const findedObj = allowedMethodArr.find((item) => item.value === selectValue);
    payment_method = findedObj?.component;
  }
  if (selectValue === 1) {
    const findedObj = allowedMethodArr.find((item) => item.value === selectValue);
    // payment_method = findedObj?.component;
    payment_method = <MercadoPagoPayment />;
  }
  if (selectValue === 2) {
    // payment_method = <ClipPayment handleClose={handleClose} />;
    const findedObj = allowedMethodArr.find((item) => item.value === selectValue);
    payment_method = findedObj?.component;
  }
  if (selectValue === '') {
    // payment_method = <ClipPayment handleClose={handleClose} />;
    payment_method = <Typography>No hay metodos de pago</Typography>;
  }

  useEffect(() => {
    if (allowedMethodArr?.length) {
      setSelectValue(allowedMethodArr[0].value);
      // setSelectValue()
    } else {
      // payment_method = <Typography>No hay metodos de pago</Typography>
      setSelectValue('');
    }
  }, [allowedMethodArr]);

  return (
    <Dialog onClose={handleClose} open={open} fullWidth maxWidth="lg">
      <Box sx={{ margin: '15px 25px 0', display: 'flex', gap: '15px', alignItems: 'center' }}>
        <Typography variant="h5">Agregar Fondos</Typography>
        <DialogSettingMethodPay />
      </Box>
      <Box sx={{ padding: '15px' }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Card>
              <CardHeader title="Metodos de Pago" />
              <CardContent>
                <RadioGroup value={selectValue} onChange={handleChangeSelected}>
                  <Grid container spacing={1}>
                    {allowedMethodArr.map((delivery) => {
                      const { value, title, description } = delivery;
                      return (
                        <Grid key={value} item xs={12}>
                          <OptionStyle
                            sx={{
                              ...(selectValue === value && {
                                boxShadow: (theme) => theme.customShadows.z8
                              })
                            }}
                          >
                            <FormControlLabel
                              value={value}
                              control={<Radio checkedIcon={<Icon icon={checkmarkCircle2Fill} />} />}
                              label={
                                <Box sx={{ ml: 1 }}>
                                  <Typography variant="subtitle2">{title}</Typography>
                                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                    {description}
                                  </Typography>
                                </Box>
                              }
                              sx={{ py: 3, flexGrow: 1, mr: 0 }}
                            />
                          </OptionStyle>
                        </Grid>
                      );
                    })}
                  </Grid>
                </RadioGroup>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6}>
            {payment_method}
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
}

const CATEGORY_SERVICE = [
  { id: 'SERVICIO', label: 'Pagos de servicio' },
  { id: 'PAQUETERIA', label: 'Paqueteria' },
  { id: 'RECARGA', label: 'Pago de recargas' }
];

const LabelStyle = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle2,
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(1)
}));

function ClipPayment({ handleClose, user }) {
  // const [referenceCode, setReferenceCode] = useState('');
  const [cancelPaymentCode, setCancelPaymentCode] = useState();
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [counterError, setCounterError] = useState(0);
  const [timerFunc, setTimerFunc] = useState();
  const countErrorLimit = 5;
  const { recargar, cobrar } = useWallet();
  // const { user } = useAuth();
  const { enqueueSnackbar } = useSnackbar();

  console.log('conteo errores', counterError);

  const ClipPaymentSchema = Yup.object().shape({
    amount: Yup.number('El monto debe ser un numero').required('El monto es requeido'),
    reference: Yup.string().required('El codigo de referencia es requerido'),
    assigned_user: Yup.string().required('El email es requerido').email()
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: '',
      reference: '',
      assigned_user: '',
      message: ''
    },
    validationSchema: ClipPaymentSchema,
    onSubmit: async (values) => {
      console.log(values);
      const newValue = values;
      newValue.amount = newValue.amount.toString();

      const obj = {
        amount: newValue.amount,
        reference: newValue.reference,
        assigned_user: newValue.assigned_user,
        message: newValue.message
      };

      // setReferenceCode(values.reference);
      setLoadingBtn(true);
      clipTransaction(obj)
        .then((res) => {
          // setLoadingBtn(false);
          setCancelPaymentCode(res.payment_request_code);
          console.log('el primero', res);

          console.log(res);
          getConfirm(newValue);
        })
        .catch((error) => {
          enqueueSnackbar('Se ha producido un error', { variant: 'error' });
          setLoadingBtn(false);
          console.log(error.response);
          console.log(error);
        });
    }
  });

  useEffect(() => {
    if (counterError === countErrorLimit) {
      console.log('se debe cancelar');
      clearInterval(timerFunc);
      setLoadingBtn(false);
      enqueueSnackbar('El codigo de referencia no se encontró, vuelve a intentarlo', { variant: 'error' });
    }
  }, [counterError, timerFunc, enqueueSnackbar]);

  const getConfirm = (values) => {
    // clipPaymentConfirm('AqjgQIT')
    //   .then((res) => console.log('respuesta', res))
    //   .catch((error) => console.log(error.response));

    setCounterError(0);

    const confirm = setInterval(() => {
      // referenceCode
      clipPaymentConfirm(values.reference)
        .then((res) => {
          // console.log('confirmadicimo---', res);

          clearInterval(confirm);
          return res;
        })
        .then(async (res) => {
          console.log('la confirmacion', res);

          const { item } = res;
          await recargar(item.amount, user.id, 'PAQUETERIA').then(async () => {
            console.log('agregado a wallet');

            // increase hace referencia a si se esta incrementando la wallet o restando
            // categoryService se refiere a que tipo de recarga es
            await firestore.collection('transactionUsers').add({
              amount: item.amount,
              increase: true,
              user_id: user.id,
              categoryService: 'PAQUETERIA',
              message: 'historia de prueba',
              rerport_id: '',
              payment_method: 'DEBIT',
              payment_source: 'CLIP',
              payment_id: values.reference,
              created_at: new Date(),
              updated_at: new Date()
            });
          });
          enqueueSnackbar('Recarga exitosa', { variant: 'success' });
          setLoadingBtn(false);
          handleClose();
        })
        .catch((error) => {
          console.log(error.response);
          setCounterError((count) => count + 1);
        });
      // console.log('confirmando');
    }, 3000);

    setTimerFunc(confirm);
    return () => clearInterval(confirm);
    // console.log('cond');
  };

  const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps } = formik;

  return (
    <FormikProvider value={formik}>
      <Form noValidate onSubmit={handleSubmit}>
        <Card sx={{ p: 3 }}>
          <Typography fontSize="20px" variant="subtitle1" marginBottom={2}>
            Pago con CLIP
          </Typography>
          <Stack direction={{ xs: 'column' }} spacing={{ xs: 3, sm: 2 }}>
            <TextField
              fullWidth
              type="number"
              label="Monto a recargar"
              {...getFieldProps('amount')}
              error={Boolean(touched.amount && errors.amount)}
              helperText={touched.amount && errors.amount}
            />
            <TextField
              fullWidth
              label="Codigo de referencia"
              {...getFieldProps('reference')}
              error={Boolean(touched.reference && errors.reference)}
              helperText={touched.reference && errors.reference}
            />
            <TextField
              fullWidth
              label="Email"
              {...getFieldProps('assigned_user')}
              error={Boolean(touched.assigned_user && errors.assigned_user)}
              helperText={touched.assigned_user && errors.assigned_user}
            />
            <TextField
              fullWidth
              label="Mensage"
              {...getFieldProps('message')}
              error={Boolean(touched.message && errors.message)}
              helperText={touched.message && errors.message}
            />
          </Stack>
          <Box marginTop={2}>
            <LabelStyle>Tipo de recarga</LabelStyle>
            <RadioGroup value="PAQUETERIA" row>
              <FormControlLabel value="PAQUETERIA" control={<Radio />} label="Paqueteria" />
            </RadioGroup>
          </Box>

          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
            <LoadingButton fullWidth type="submit" variant="contained" loading={loadingBtn}>
              Pagar
            </LoadingButton>
          </Box>
        </Card>
      </Form>
    </FormikProvider>
  );
}

function MercadoPagoPayment() {
  const [amount, setAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showMercBtn, setShowMercBtn] = useState(false);
  const [verificado, setVerificado] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const verifyAmount = () => {
    if (amount >= 10) {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        setShowMercBtn(true);
        setVerificado(true);
      }, 1000);
    } else {
      enqueueSnackbar('Ingrese un monto mayor a $ 10', { variant: 'error' });
    }
  };

  return (
    <Card sx={{ p: 3 }}>
      <Typography fontSize="20px" variant="subtitle1" marginBottom={2}>
        Pago con Mercado Pago
      </Typography>
      <TextField
        fullWidth
        type="number"
        abel="Monto a recargar"
        label="Monto a recargar"
        disabled={verificado}
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
      />

      <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
        {!verificado && (
          <LoadingButton fullWidth variant="contained" loading={loading} onClick={verifyAmount}>
            Verificar monto
          </LoadingButton>
        )}
        {showMercBtn && verificado && (
          <ButtonRecargaMercPago
            items={[{ title: 'recarga', unit_price: Number(amount), quantity: 1 }]}
            amount={amount.toString()}
          />
        )}
      </Box>
    </Card>
  );
}
